import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  listingInquiry: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'listing-inquiry' }),
  multipostInquiry: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'multipost-inquiry' }),
  rentalInquiry: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'rental-inquiry' }),
}

export { paths }
